import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const FloatingLabelInput = React.forwardRef((props, ref) => {
  const { label, onChange, onBlur, onFocus, ...inputProps } = props;

  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(inputProps.value || '');

  // Use the controlled input value if available and fallback to local state for uncontrolled inputs
  const currentValue = 'value' in inputProps ? inputProps.value : value;

  return (
    <label
      className={clsx(
        'floating',
        focused && 'focus',
        (focused || currentValue.length > 0) && 'not-empty'
      )}
    >
      <span>{label}</span>
      <input
        onChange={e => {
          // Keep the local state up to date
          setValue(e.target.value);
          onChange && onChange(e);
        }}
        onBlur={e => {
          setFocused(false);
          onBlur && onBlur(e);
        }}
        onFocus={e => {
          setFocused(true);
          onFocus && onFocus(e);
        }}
        {...inputProps}
        ref={ref}
      />
    </label>
  );
});

FloatingLabelInput.displayName = 'FloatingLabelInput';

FloatingLabelInput.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
};

export default FloatingLabelInput;
